module.exports = __webpack_public_path__ + "img/mb_header_bg.2b879c8.webp";